import './caffeamici/style';
import FormStructure from './caffeamici/form_structure';

export default FormStructure;